import {Component, OnInit, EventEmitter} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {IosAppUserService} from '../../../_services/ios-app-user.service';
import {UppercaseDirective} from '../../../_directives/uppercase.directive';
import {IosAppUserModel} from '../../../_models/ios-app-user'

@Component({
    selector: 'app-add-ios-app-user',
    templateUrl: './add-ios-app-user.component.html',
    styleUrls: []
})

export class AddIosAppUserComponent extends DialogComponent<IosAppUserModel, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    mailExist = false;
    focusEventEmitter = new EventEmitter<boolean>();

    constructor(dialogService: DialogService, private iosAppUserService: IosAppUserService) {
        super(dialogService);
    }
 
    ngOnInit() {
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    add() {
        this.loading = true;
        this.message = '';
        this.iosAppUserService.add(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            }
            else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/ios-app-user/add-ios-app-user/add-ios-app-user.component.ts